import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Firebase 설정
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
const emulator = process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true';
const expectedProject = emulator ? firebaseConfig.projectId : 'rental-news-b';
if ((emulator && (process.env.NODE_ENV !== 'development' || !expectedProject?.startsWith('demo-')))
  || firebaseConfig.projectId !== expectedProject
  || firebaseConfig.storageBucket !== `${expectedProject}.firebasestorage.app`) {
  throw new Error('Firebase 실행 환경이 일치하지 않습니다. 프로젝트와 Emulator 설정을 확인해주세요.');
}

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firestore 초기화
export const db = getFirestore(app);

// Storage 초기화
export const storage = getStorage(app);

// Auth 초기화
export const auth = getAuth(app);

// 개발 환경에서 에뮬레이터 연결
if (emulator) {
  connectFirestoreEmulator(db, '127.0.0.1', 8088);
  connectStorageEmulator(storage, '127.0.0.1', 9198);
  connectAuthEmulator(auth, 'http://127.0.0.1:9098');
}

export default app;
